(() => {
  if (window.smilunoraFixedPackages) return;
  window.smilunoraFixedPackages = true;
  const base = window.Shopify?.routes?.root || '/';
  const configs = {
    15405282197581: {quantities:[1,2,4,8], gifts:[{at:4,id:67649098186829,gift:"30ck"},{at:8,id:67649098154061,gift:"88Ib"}]},
    15434570301517: {quantities:[1,3,6,10,20,40], gifts:[{at:20,id:67788031098957,gift:"1HCb"},{at:40,id:67788025790541,gift:"VERy"}]}
  };
  let busy = false;
  let editTimer,editing=false;
  let failed = false;
  let cachedCart=null;
  const pending=new Map();
  function state(control){
    const raw=control?.querySelector('[data-fixed-cart-state]')?.textContent;
    try{return raw?JSON.parse(raw):cachedCart;}catch{return cachedCart;}
  }
  function identity(item){return JSON.stringify([item.product_id,item.variant_id,item.properties||{}]);}
  function rendering(){
    const sections=['cart-drawer'];
    ['main-cart-items','main-cart-footer'].forEach(id=>{const section=document.getElementById(id)?.dataset.id;if(section)sections.push(section);});
    if(document.getElementById('cart-icon-bubble'))sections.push('cart-icon-bubble');
    return {sections:[...new Set(sections)],sections_url:base+'cart'};
  }
  function chargedGift(){return document.querySelector('[data-fixed-gift-price]:not([data-fixed-gift-price="0"])');}
  async function request(endpoint,data) {
    let frame;
    try{
      let send=window.fetch.bind(window);
      if(endpoint==='cart/add.js'){
        frame=document.createElement('iframe');frame.hidden=true;frame.setAttribute('aria-hidden','true');frame.tabIndex=-1;document.body.append(frame);
        send=frame.contentWindow.fetch.bind(frame.contentWindow);
      }
      const response=await send(new URL(base+endpoint,location.origin).href,{method:data?'POST':'GET',credentials:'same-origin',headers:{Accept:'application/json',...(data?{'Content-Type':'application/json'}:{})},...(data?{body:JSON.stringify(data)}:{})});
      const result=await response.json();
      if(!response.ok||result.errors||result.status>=400)throw Error('Cart update failed');
      return result;
    }finally{frame?.remove();}
  }
  function lock() {
    busy = true;
    document.documentElement.dataset.fixedPackageBusy = 'true';
    document.querySelectorAll('[name=checkout]').forEach(el=>{if(!el.disabled){el.dataset.fixedLocked='true';el.disabled=true;}});
  }
  function unlock(success) {
    busy = false;
    failed = !success;
    delete document.documentElement.dataset.fixedPackageBusy;
    document.querySelectorAll('[data-fixed-locked]').forEach(el=>{if(success || el.matches('[data-fixed-quantity], [data-fixed-step]')){el.disabled=false;delete el.dataset.fixedLocked;}});
    enableSelectors();
  }
  function children(cart,parent) {
    if(!parent)return [];
    let parentBundle;try{parentBundle=JSON.parse(parent.properties?.__kaching_bundles||'null');}catch{}
    return cart.items.filter(item=>{
      if(item.parent_relationship)return item.parent_relationship.parent_key===parent.key;
      let bundle;try{bundle=JSON.parse(item.properties?.__kaching_bundles||'null');}catch{}
      if(parentBundle?.id&&bundle?.gift&&bundle.id===parentBundle.id&&configs[parent.product_id]?.gifts.some(gift=>gift.id===item.variant_id))return true;
      return String(item.properties?._smilunora_package_gift)===String(parent.product_id)&&cart.items.filter(line=>line.product_id===parent.product_id).length===1;
    });
  }
  async function refresh(cart) {
    let doc=new DOMParser().parseFromString(Object.values(cart.sections||{}).filter(Boolean).join('\n'),'text/html');
    const targets=['cart-drawer','#main-cart-items','#main-cart-footer','#cart-icon-bubble'];
    if(targets.some(selector=>document.querySelector(selector)&&!doc.querySelector(selector))){
      const response=await fetch(base+'cart',{credentials:'same-origin',headers:{Accept:'text/html'}});
      if(!response.ok)throw Error('Cart refresh failed');
      doc=new DOMParser().parseFromString(await response.text(),'text/html');
    }
    const drawer=document.querySelector('cart-drawer');
    const open=drawer?.classList.contains('active');
    for(const selector of targets){
      const target=document.querySelector(selector),source=doc.querySelector(selector);
      if(target&&!source)throw Error('Cart refresh failed');
      if(target&&source)target.innerHTML=source.innerHTML;
    }
    document.querySelectorAll('cart-items,cart-drawer-items,cart-drawer').forEach(el=>el.classList.toggle('is-empty',cart.item_count===0));
    if(open&&cart.item_count)drawer?.open();
    cachedCart=cart;
    for(const task of pending.values()){
      document.querySelectorAll('[data-fixed-quantity]').forEach(input=>{
        const line=cart.items.find(item=>item.key===input.dataset.key);
        if(line&&identity(line)===task.token)input.value=task.quantity;
      });
    }
  }
  function giftProperties(parent,gift,oldChildren) {
    const properties={...oldChildren.find(item=>item.variant_id===gift.id)?.properties,_smilunora_package_gift:String(parent.product_id)};
    if(!properties.__kaching_bundles&&gift.gift&&parent.properties?.__kaching_bundles){
      const metadata=JSON.parse(parent.properties.__kaching_bundles);
      properties.__kaching_bundles=JSON.stringify({id:metadata.id,deal:metadata.deal,v:metadata.v,gift:gift.gift});
    }
    return properties;
  }
  function showError(control,key='error') {
    const text=control?.dataset[key] || document.querySelector('.fixed-package-control')?.dataset[key] || window.cartStrings?.error || 'Please refresh your cart and try again.';
    let target=control?.querySelector('[role=status]') || document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
    if(!target){target=document.createElement('p');target.setAttribute('role','alert');(document.querySelector('cart-items,cart-drawer')||document.body).append(target);}
    target.textContent=text;
  }
  async function change(productId,key,quantity,control) {
    const config=configs[productId];
    if(!config || (!Number.isSafeInteger(quantity)||quantity<0)){showError(control,'invalid');return;}
    const snapshot=state(control);
    const original=snapshot?.items.find(item=>item.key===key);
    const token=original?identity(original):key;
    pending.set(token,{productId,key,quantity,token});
    if(busy)return;
    lock();
    const status=control?.querySelector('[role=status]');
    if(status)status.textContent='';
    let success=false;
    try{
      let cart=snapshot||cachedCart||await request('cart.js');
      while(pending.size){
      const task=pending.values().next().value;
      pending.delete(task.token);
      const {productId,quantity}=task;
      const config=configs[productId];
      let parent=cart.items.find(item=>identity(item)===task.token)||cart.items.find(item=>item.key===task.key&&item.product_id===Number(productId));
      if(!parent)throw Error('Cart changed');
      const oldChildren=children(cart,parent);
      const variantId=parent.variant_id,properties=JSON.stringify(parent.properties||{});
      const sameParent=item=>item.variant_id===variantId&&item.product_id===Number(productId)&&JSON.stringify(item.properties||{})===properties;
      const gifts=quantity?config.gifts.filter(gift=>quantity>=gift.at):[];
      const updates={[parent.key]:quantity};
      oldChildren.forEach(item=>{updates[item.key]=gifts.some(gift=>gift.id===item.variant_id)?1:0;});
      cart=await request('cart/update.js',{updates,...rendering()});
      if(quantity){
        parent=cart.items.find(sameParent);
        if(!parent||parent.quantity!==quantity)throw Error('Package quantity mismatch');
        const missing=gifts.filter(gift=>!children(cart,parent).some(item=>item.variant_id===gift.id));
        if(missing.length){
          const added=await request('cart/add.js',{items:missing.map(gift=>({id:gift.id,quantity:1,parent_line_key:parent.key,properties:giftProperties(parent,gift,oldChildren)})),...rendering()});
          cart={...await request('cart.js'),sections:added.sections};
          parent=cart.items.find(sameParent);
        }
        const included=children(cart,parent);
        if(gifts.some(gift=>!included.some(item=>item.variant_id===gift.id&&item.quantity===1&&item.final_line_price===0))||included.some(item=>!gifts.some(gift=>gift.id===item.variant_id)))throw Error('Gift discount unavailable');
      }
      await refresh(cart);
      }
      success=true;
    }catch(error){pending.clear();try{await refresh(await request('cart.js'));}catch(refreshError){}showError(document.querySelector('.fixed-package-control'));}
    finally{unlock(success);}
  }
  document.addEventListener('input',event=>{
    const input=event.target.closest('[data-fixed-quantity]');if(!input)return;
    event.stopImmediatePropagation();clearTimeout(editTimer);editing=true;
    editTimer=setTimeout(()=>{
      editing=false;
      if(input.validity.valid)change(input.dataset.product,input.dataset.key,Number(input.value),input.closest('.fixed-package-control'));
      else showError(input.closest('.fixed-package-control'),'invalid');
    },450);
  },true);
  document.addEventListener('change',event=>{
    const select=event.target.closest('[data-fixed-quantity]');
    if(!select)return;
    clearTimeout(editTimer);editing=false;
    event.stopImmediatePropagation();
    if(!select.validity.valid){showError(select.closest('.fixed-package-control'),'invalid');return;}
    change(select.dataset.product,select.dataset.key,Number(select.value),select.closest('.fixed-package-control'));
  },true);
  document.addEventListener('click',event=>{
    const stepButton=event.target.closest('[data-fixed-step]');
    if(stepButton){
      event.preventDefault();event.stopImmediatePropagation();
      if(stepButton.disabled)return;
      clearTimeout(editTimer);editing=false;
      const input=stepButton.closest('.fixed-package-control').querySelector('[data-fixed-quantity]');
      const quantity=Number(input.value)+Number(stepButton.dataset.fixedStep)*Number(input.step||1);
      if(quantity<Number(input.min||1)||(input.max&&quantity>Number(input.max)))return;
      input.value=quantity;
      enableSelectors();
      editing=true;document.documentElement.dataset.fixedPackageBusy='true';
      editTimer=setTimeout(()=>{editing=false;change(input.dataset.product,input.dataset.key,quantity,input.closest('.fixed-package-control'));},180);
      return;
    }
    const remove=event.target.closest('[data-fixed-remove]');
    if(remove){
      event.preventDefault();event.stopImmediatePropagation();
      const row=remove.closest('[data-fixed-package-row]');
      if(row)change(row.dataset.fixedProduct,row.dataset.fixedKey,0,row.querySelector('.fixed-package-control'));
      return;
    }
    if(!event.target.closest('[name=checkout]'))return;
    const invalid=Array.from(document.querySelectorAll('[data-fixed-quantity]')).find(select=>!select.validity.valid);
    if(busy||editing||failed||invalid||chargedGift()){event.preventDefault();event.stopImmediatePropagation();if(!invalid)showError(document.querySelector('.fixed-package-control'));if(invalid){showError(invalid.closest('.fixed-package-control'),'invalid');invalid.focus();}}
  },true);
  document.addEventListener('submit',event=>{
    if(!event.target.matches('form[action$="/cart"]'))return;
    const invalid=Array.from(document.querySelectorAll('[data-fixed-quantity]')).some(select=>!select.validity.valid);
    if(busy||editing||failed||invalid||chargedGift()){event.preventDefault();event.stopImmediatePropagation();}
  },true);
  function enableSelectors(){
    document.querySelectorAll('[data-fixed-quantity]').forEach(input=>{
      input.disabled=false;
      const group=input.closest('.fixed-package-control');
      group.querySelector('[data-fixed-step="-1"]').disabled=Number(input.value)<=Number(input.min||1);
      group.querySelector('[data-fixed-step="1"]').disabled=Boolean(input.max)&&Number(input.value)>=Number(input.max);
    });
  }
  new MutationObserver(enableSelectors).observe(document.documentElement,{childList:true,subtree:true});
  enableSelectors();
})();
